import { z } from "zod";

export const moveDataSourceToCategoryFormSchema = z.object({ category: z.string() });
